window.addEventListener("DOMContentLoaded", (event) => {

  // Get placeholder text from data attributes
  const headerSearchEl = document.querySelector("#search");
  const indexSearchEl = document.querySelector("#index-search");
  const headerPlaceholder = headerSearchEl?.getAttribute("data-placeholder-search") || "Search";
  const indexPlaceholder = indexSearchEl?.getAttribute("data-placeholder-search") || "Search";

  // Pagefind used in the header - only initialize if element exists
  if (headerSearchEl) {
    let headerPagefind = new PagefindUI(
      { 
        element: "#search",
        pageSize: 20,
        showSubResults: false,
        showEmptyFilters: false,
        resetStyles: true,
        excerptLength: 8,
        debounceTimeoutMs: 300,
        translations: {
          placeholder: headerPlaceholder
        }
      }
    );
  }

  // Pagefind used in the index page - only initialize if element exists
  if (indexSearchEl) {
    let indexPagefind = new PagefindUI(
      { 
        element: "#index-search",
        pageSize: 20,
        showSubResults: false,
        showEmptyFilters: false,
        resetStyles: true,
        excerptLength: 8,
        debounceTimeoutMs: 300,
        translations: {
          placeholder: indexPlaceholder
        }
      }
    );
  }

  const searchButton = document.querySelector("#searchButton"),
        searchWrapper = document.querySelector("#searchWrapper"),
        searchInput = document.querySelector(".pagefind-ui__search-input"),
        searchModalClose = document.querySelector("#searchModalClose");
  
  const openSearchUi = () => {
    searchButton.classList.toggle("bg-stone-100");
    searchWrapper.classList.toggle("hidden");
    document.body.classList.toggle("overflow-y-hidden");
    searchInput.focus();
  }

  const closeSearchUi = () => {
    searchButton.classList.remove("bg-stone-100");
    searchWrapper.classList.add("hidden");
    document.body.classList.remove("overflow-y-hidden");
  }
  
  if (searchButton && searchWrapper) {

    const searchArea = document.querySelector("#search");

    // Handle document-wide clicks
    document.addEventListener("click", (event) => {
      // Check if search wrapper is visible and click is outside search area
      if (!searchWrapper.classList.contains("hidden") && 
          !searchArea.contains(event.target) && 
          !searchButton.contains(event.target)) {
        closeSearchUi();
      }
    });

    // Prevent search area clicks from triggering the document click handler
    searchArea.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    // Prevent clicks inside search area from bubbling up
    searchArea.addEventListener("mousedown", (event) => {
      event.stopPropagation();
    });

    searchArea.addEventListener("touchstart", (event) => {
      event.stopPropagation();
    });

    // Handle both mouse and touch events for closing modal
    const closeOnBackground = (event) => {
      if (event.target === searchWrapper) {
        closeSearchUi();
      }
    };

    searchWrapper.addEventListener("mousedown", closeOnBackground);
    searchWrapper.addEventListener("touchstart", closeOnBackground);

    // Open search UI modal with button
    searchButton.addEventListener("click", () => {
      openSearchUi();
    });

    // Close search UI modal with button
    searchModalClose.addEventListener("click", (event) => {
      closeSearchUi();
    });

    // Close search UI modal with escape key
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeSearchUi();
      }
    });

  }

});